var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    !_vm.isUploading && !_vm.isDone
      ? _c("div", { staticClass: "card-content has-text-centered" }, [
          _c("h1", { staticClass: "title is-3" }, [
            _vm._v(
              "Eliminar " +
                _vm._s(_vm.files.length) +
                " documento" +
                _vm._s(_vm.files.length ? "s" : "")
            ),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "subtitle is-5" }, [
            _vm._v("¿Está seguro que desea eliminar los documentos?"),
          ]),
        ])
      : _c("div", { staticClass: "card-content" }, [
          _c("table", { staticClass: "table is-narrow is-fullwidth" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.filesCopy, function (file, i) {
                  return _c("tr", { key: `file-${i}` }, [
                    _c("td", [
                      _c("p", [
                        _vm._v(_vm._s(file.nombre) + "\n                "),
                        _vm.filesSucceded.includes(i)
                          ? _c("span", { staticClass: "has-text-success" }, [
                              _vm._v(" "),
                              _c("i", { staticClass: "fas fa-check-circle" }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filesFailed.includes(i)
                          ? _c("span", { staticClass: "has-text-danger" }, [
                              _vm._v(" "),
                              _c("i", { staticClass: "fas fa-times-circle" }),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.filesErrors[i]
                        ? _c(
                            "p",
                            { staticClass: "has-text-danger is-size-7" },
                            [_vm._v(_vm._s(_vm.filesErrors[i]))]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm.filesCopy.length == 0 ? _c("tr", [_vm._m(1)]) : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
    _vm._v(" "),
    !_vm.isUploading && !_vm.isDone
      ? _c("footer", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "card-footer-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "card-footer-item has-text-weight-bold has-text-danger is-uppercase",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [_vm._v("Eliminar")]
          ),
        ])
      : !_vm.isUploading && _vm.isDone
      ? _c("footer", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "card-footer-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cerrar")]
          ),
        ])
      : _vm.isUploading
      ? _c("footer", { staticClass: "card-footer" }, [_vm._m(2)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [_c("th", [_vm._v("Nombre")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("i", [_vm._v("- No hay archivos para eliminar -")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "card-footer-item animated flash slow",
        attrs: { type: "button" },
      },
      [
        _c("i", { staticClass: "fas fa-sync fa-spin" }),
        _vm._v(" Eliminando archivos"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }